var lib_core          = require("lib-core");
var showUI;
if(showUI = (typeof window !== 'undefined'))
    var ui_extensions = require("ui-extensions");
var editor_2d         = require("editor-2d");

var Editor2DController = require("./../editor2D/editor2DController.js");
var RotateStateMachine = require("./rotateStateMachine");
var RotateModel = require("./rotateModel.js");

var RotateController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        ROTATE_BUTTON: {id: 'abs_24', name: "ROTATE_BUTTON", isGuiButton: true }
    });
};

lib_core.inherit(RotateController, lib_core.Controller);
if(showUI) {
    RotateController.inject = {
        editor2DController : Editor2DController,
        tabController : ui_extensions.TabController
    };
} else {
    RotateController.inject = {
        editor2DController : Editor2DController
    };
}
module.exports = RotateController;

RotateController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    this.tabController.getView().registerButton({
        name: 'Rotate',
        title: 'Rotate (L)',
        sortOrder: 2,
        eventType: lib_core.GuiEvents.ROTATE_BUTTON,
        style: {
            icon: 'icon-rotate-ccw.svg',
        },
        group: "modifier"
    });
};

RotateController.prototype.createStateMachine = function () {
    return new RotateStateMachine(this.root, this.getModel());
};

RotateController.prototype.createModel = function () {
    var rotateModel = new RotateModel();

    if(this.configuration.rotateAngle)
        rotateModel.rotateAngle = this.configuration.rotateAngle;

    return rotateModel;
};

RotateController.prototype.afterLoad = function () {
    var self = this;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    var editorController = this.editor2DController;
    editorController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};
